import { ClientIntakeResponsesPathParams } from '../clientIntakeResponses.firebase.repo';
import { ClientIntakeResponse } from './clientIntakeResponses.firebase.models';

export class SetClientIntakeResponsesConnection {
	static readonly type =
		'[Client Intake Responses] Set client intake responses connection';
	constructor(
		public connect: boolean,
		public pathParams: ClientIntakeResponsesPathParams,
	) {}
}

export class ClearClientIntakeResponsesConnectionAndState {
	static readonly type =
		'[Client Intake Responses] Clear client intake responses connection and state';
}

export class SetClientIntakeResponses {
	static readonly type =
		'[Client Intake Responses] Set client intake responses';
	constructor(public items: ClientIntakeResponse[]) {}
}

export class UpsertClientIntakeResponses {
	static readonly type =
		'[Client Intake Responses] Upsert client intake responses';
	constructor(public clientIntakeResponses: ClientIntakeResponse[]) {}
}

export class UpdateClientIntakeResponse {
	static readonly type =
		'[Client Intake Responses] Update client intake response';
	constructor(
		public clientIntakeResponse: Partial<ClientIntakeResponse> & { id: string },
	) {}
}
